<template>
  <v-card outlined class="mb-2">
    <v-list-item>
      <v-list-item-avatar>
        <v-avatar>
          <v-icon v-if="item.doc_upload" color="green" size="30">mdi-file-check</v-icon>
          <v-icon v-else>mdi-file-alert</v-icon>
        </v-avatar>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-subtitle class="mb-2">{{ date }}</v-list-item-subtitle>
        <v-list-item-title class="mb-2">
          {{ personal.firstName }}
          {{ personal.middleName }}
          {{ personal.lastName }} - {{ address }}
        </v-list-item-title>
        <v-list-item-subtitle>{{ personal.email }}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-row no-gutters>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="grey" v-on="on" @click="pdf()">
                  <v-icon>mdi-play</v-icon>
                </v-btn>
              </template>
              <span>Generate application PDF</span>
            </v-tooltip>
          </v-col>
          <v-col v-if="item.fileId">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="grey" v-on="on" @click="preview()">
                  <v-icon>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span>View application PDF</span>
            </v-tooltip>
          </v-col>
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="grey" v-on="on" @click="document()">
                  <v-icon>mdi-file-upload</v-icon>
                </v-btn>
              </template>
              <span>Upload Documents</span>
            </v-tooltip>
          </v-col>
          <v-col @click="drive()">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon color="grey" v-on="on">
                  <v-icon>mdi-folder-google-drive</v-icon>
                </v-btn>
              </template>
              <span>Go to documents folder</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-list-item-action>
    </v-list-item>
  </v-card>
</template>

<script>
import { functions } from "../assets/js/firebase.js";
import moment from "moment";
export default {
  props: ["item"],
  computed: {
    personal() {
      let { personalInfo } = this.item;
      if (personalInfo) return personalInfo;
      return {};
    },
    address() {
      return this.item.leaseInfo.add1;
    },
    date() {
      return moment(new Date(this.item.timestamp)).format(
        "DD MMM YYYY HH:MM a"
      );
    }
  },

  methods: {
    drive() {
      window.open(
        `https://drive.google.com/drive/folders/${this.item.folderId}`,
        "_blank"
      );
    },
    preview() {
      window.open(
        `https://drive.google.com/file/d/${this.item.fileId}/view`,
        "_blank"
      );
    },
    document() {
      const vm = this;
      let routeData = this.$router.resolve({
        path: "/documents/" + vm.item.id
      });
      window.open(routeData.href, "_blank");
    },
    pdf() {
      const vm = this;
      let addPDF = functions.httpsCallable("addPDF");
      vm.$root.loader = true;
      addPDF({ id: vm.item.id })
        .then(({ data }) => {
          let { message } = data;
          vm.$root.loader = false;
          vm.$root.alert(message);
          vm.$emit("onPDF");
        })
        .catch(({ message }) => {
          vm.$root.alert(message);
          vm.$root.loader = false;
        });
    }
  }
};
</script>

<style></style>
